var map = {
	"./cradleceremony1.jpg": 8685,
	"./cradleceremony10.jpg": 9921,
	"./cradleceremony11.jpg": 6196,
	"./cradleceremony12.jpg": 675,
	"./cradleceremony13.jpg": 2150,
	"./cradleceremony14.jpg": 3597,
	"./cradleceremony15.jpg": 2672,
	"./cradleceremony16.jpg": 7007,
	"./cradleceremony17.jpg": 690,
	"./cradleceremony18.jpg": 3609,
	"./cradleceremony19.jpg": 9260,
	"./cradleceremony2.jpg": 8786,
	"./cradleceremony20.jpg": 6656,
	"./cradleceremony21.jpg": 8397,
	"./cradleceremony22.jpg": 594,
	"./cradleceremony3.jpg": 1167,
	"./cradleceremony4.jpg": 6228,
	"./cradleceremony5.jpg": 4273,
	"./cradleceremony6.jpg": 7574,
	"./cradleceremony7.jpg": 4035,
	"./cradleceremony8.jpg": 5896,
	"./cradleceremony9.jpg": 3061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2528;